export const BASE_URL_V2 = import.meta.env.VITE_APP_API_URL_V2;
export const BASE_URL_STRAPI = import.meta.env.VITE_APP_API_URL_STRAPI;
export const BASE_URL_STRAPI_TOKEN = import.meta.env.VITE_APP_API_URL_STRAPI_TOKEN;
export const SOCKET_URL = import.meta.env.VITE_APP_SOCKET_URL;
export const MEET_URL = import.meta.env.VITE_APP_MEET_URL;
export const WEBSITE_URL = import.meta.env.VITE_APP_WEBSITE_URL;
export const BACKGROUND_CHECKS_URL =
  import.meta.env.VITE_APP_BACKGROUND_CHECKS_URL || "https://go-2-work.com/background-checks";
export const TERMS_AND_CONDITIONS_URL =
  import.meta.env.VITE_APP_TERMS_AND_CONDITIONS_URL || "https://go2work.com/terms-and-conditions";
export const PRIVACY_POLICY_URL =
  import.meta.env.VITE_APP_PRIVACY_POLICY_URL || "https://go2work.com/privacy-policy";
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_APP_STRIPE_PUBLISHABLE_KEY;
export const FIREBASE_API_KEY = import.meta.env.VITE_APP_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = import.meta.env.VITE_APP_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET = import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = import.meta.env.VITE_APP_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = import.meta.env.VITE_APP_FIREBASE_APP_ID;
export const FIREBASE_MEASUREMENT_ID = import.meta.env.VITE_APP_FIREBASE_MEASUREMENT_ID;
export const FIREBASE_VAPID_KEY = import.meta.env.VITE_APP_FIREBASE_VAPID_KEY;
export const REVENUECAT_APP_PUBLIC_API_KEY = import.meta.env.VITE_APP_REVENUECAT_APP_PUBLIC_API_KEY;
export const isProduction = import.meta.env.MODE?.toLowerCase() === "production";
export const POSTHOG_API_KEY = import.meta.env.VITE_APP_POSTHOG_API_KEY;
export const POSTHOG_HOST = import.meta.env.VITE_APP_POSTHOG_HOST;
export const MODE = import.meta.env.MODE;
export const SENTRY_RELEASE = import.meta.env.VITE_APP_SENTRY_RELEASE;
export const SUGGESTIONS_URL = import.meta.env.VITE_APP_SUGGESTIONS_URL;

// Environment detection helpers
export const isDevelopment = import.meta.env.MODE === "development" || import.meta.env.DEV;
export const isStaging = import.meta.env.MODE === "Staging" || import.meta.env.MODE === "staging";
export const shouldEnablePosthog = isProduction && !!POSTHOG_API_KEY;
